export default __webpack_public_path__ + "static/media/mutuo-300w-min.26008a72.jpeg";